import React, { useEffect, useId, useState } from "react";
import styles from "./TruncatedText.module.scss";
import { useCarConfigLabel } from "../../../utils/labelUtils";
import Icon from "../../../../shared-components/css-modules/lexus/atoms/Icon";
import Button from "../../../../shared-components/css-modules/lexus/atoms/Button";
import Text from "../../../../shared-components/css-modules/lexus/atoms/Text";

type TruncatedTextProps = {
    text: string;
    maxLength?: number;
};

const TruncatedText: React.FC<TruncatedTextProps> = ({ text, maxLength = 200 }) => {
    const showMoreText = useCarConfigLabel("carConfigEngineShowMore");
    const showLessText = useCarConfigLabel("carConfigEngineShowLess");
    const [isExpanded, setIsExpanded] = useState(false);
    const [shouldTruncate, setShouldTruncate] = useState(false);

    const textId = useId();

    useEffect(() => {
        // Check if the text length exceeds the maximum length plus a buffer
        setShouldTruncate(text.length > maxLength + 50);
    }, [text, maxLength]);

    const displayText = isExpanded || !shouldTruncate ? text : `${text.slice(0, maxLength).trim()}...`;

    if (!shouldTruncate) {
        return <p className={styles.textContainer}>{text}</p>;
    }

    return (
        <div className={styles.textContainer}>
            <Text variant="apheleia-body" id={textId}>
                {displayText}
            </Text>

            <Button
                className={styles.toggleButton}
                variant="clean"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-controls={textId}
                aria-expanded={isExpanded}
                aria-label={isExpanded ? `${showLessText}` : `${showMoreText}`}
            >
                {isExpanded ? (
                    <>
                        <Text variant="apheleia-caption" className={styles["show-more-less"]}>
                            {showLessText}
                        </Text>
                        <Icon variant="chevron-up" sizing="sm" aria-hidden="true" />
                    </>
                ) : (
                    <>
                        <Text variant="apheleia-caption" className={styles["show-more-less"]}>
                            {showMoreText}
                        </Text>
                        <Icon variant="chevron-down" sizing="sm" aria-hidden="true" />
                    </>
                )}
            </Button>
        </div>
    );
};

export default TruncatedText;
